import cx from 'classnames';
import styles from './Header.module.scss';

import { FC } from 'react';
import { PATH } from '../../app';
import { Button } from '../Button';
import { UserInfo } from '../UserInfo';
import { RawButton } from '../RawButton';
import { useWindowSize } from '@utils/hooks';
import { UserDto } from '../../app/store/api/tunedRestApi';
import { LanguagePicker } from '@shared/LanguagePicker';

interface HeaderProps {
  user?: UserDto;
  avatar?: string;
  className?: string;
  classNameButton?: string;
  leftButtonTitle?: string;
  rightButtonTitle?: string;
  onImgClick?: () => void;
  leftButtonOnClick?: () => void;
  rightButtonOnClick?: () => void;
}

export const Header: FC<HeaderProps> = ({
  user,
  avatar,
  className,
  classNameButton,
  leftButtonTitle,
  rightButtonTitle,
  onImgClick,
  leftButtonOnClick,
  rightButtonOnClick,
}) => {
  const { width: screenWidth } = useWindowSize();

  return (
    <div className={cx(styles.header, className)}>
      <div className={styles.headerContent}>
        <RawButton
          onClick={onImgClick}
          className={cx(styles.hLogo, { [styles.hLogoClick]: onImgClick })}
        >
          <img
            alt="logo"
            width={screenWidth > 1200 ? 65 : 37}
            height={screenWidth > 1200 ? 61 : 32}
            src="/images/logo.webp"
          />
        </RawButton>
        <div className={styles.headerLangAndUser}>
          <LanguagePicker className={styles.languagePicker} />

          {user ? (
            <UserInfo
              avatar={avatar}
              username={user.username ?? ''}
              userAccountLink={PATH.LOTTERY_ALL_AT_ONCE}
            />
          ) : (
            <div className={styles.headerButtons}>
              {leftButtonTitle && leftButtonOnClick && (
                <Button
                  variant="outlined"
                  title={leftButtonTitle}
                  onClick={leftButtonOnClick}
                  typographyClassName={styles.hButtonText}
                  className={cx(styles.hButton, classNameButton)}
                />
              )}
              {rightButtonTitle && rightButtonOnClick && (
                <Button
                  variant="filled"
                  title={rightButtonTitle}
                  onClick={rightButtonOnClick}
                  typographyClassName={styles.hButtonText}
                  className={cx(styles.hButton, classNameButton)}
                />
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
